// convert the gql document to a string
export const getGqlString = (doc: any) => doc.loc && doc.loc.source.body;

// TODO: Using native fetch here as graphql-request does not support cookies. Consider updating if support is added in the future.
export const customFetcher = async (
  url: string,
  options: {
    query: string;
    variables?: any;
    signal?: AbortSignal;
  },
) => {
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    mode: 'cors',
    body: JSON.stringify(options),
    signal: options.signal,
  });
  return response.json();
};
